/**
* 商户管理  工资模板
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>工资模板</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.templateName" placeholder="输入绩效模板名"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column sortable prop="templateName" label="模板名" width="180">
      </el-table-column>
      <el-table-column sortable prop="ordinaryHandmade" label="普通手工提成" width="180">
        <template slot-scope="scope">
          <div>{{scope.row.ordinaryHandmade|formatPercentage}}</div>
        </template>
      </el-table-column>
      <el-table-column sortable prop="memberHandmade" label="会员手工提成" width="180">
        <template slot-scope="scope">
          <div>{{scope.row.memberHandmade|formatPercentage}}</div>
        </template>
      </el-table-column>
      <el-table-column sortable prop="newCard" label="新卡提成" width="180">
        <template slot-scope="scope">
          <div>{{scope.row.newCard|formatPercentage}}</div>
        </template>
      </el-table-column>
      <el-table-column sortable prop="renewCard" label="续卡提成" width="180">
        <template slot-scope="scope">
          <div>{{scope.row.renewCard|formatPercentage}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="200">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteSalaryTemplate(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="模板名" prop="templateName">
          <el-input size="small" v-model="editForm.templateName" auto-complete="off" placeholder="请输入模板名"></el-input>
        </el-form-item>
        <el-form-item label="普通手工提成" prop="ordinaryHandmade">
          <el-input size="small" v-model="editForm.ordinaryHandmade" auto-complete="off" placeholder="请输入普通手工提成">
            <template slot="append">%</template>
          </el-input>

        </el-form-item>
        <el-form-item label="会员手工提成" prop="memberHandmade">
          <el-input size="small" v-model="editForm.memberHandmade" auto-complete="off" placeholder="请输入会员手工提成">
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
        <el-form-item label="新卡提成" prop="newCard">
          <el-input size="small" v-model="editForm.newCard" auto-complete="off" placeholder="请输入新卡提成">
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
        <el-form-item label="续卡提成" prop="renewCard">
          <el-input size="small" v-model="editForm.renewCard" auto-complete="off" placeholder="请输入续卡提成">
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm()">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  performanceTemplatePage,
  savePerformanceTemplate,
  delPerformanceTemplatePage,
} from '../../api/userMG'
import {formatPercentage} from '../../utils/util'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '绩效模板',
      postForm:{
        templateId: '',
        templateName: '',
        ordinaryHandmade: 0.00,
        memberHandmade:0.00,
        newCard:0.00,
        renewCard:0.00,
        token: '',
      },
      editForm: {
        templateId: '',
        templateName: '',
        ordinaryHandmade: 0.00,
        memberHandmade:0.00,
        newCard:0.00,
        renewCard:0.00,
        token: localStorage.getItem('logintoken')
      },
      // rules表单验证
      rules: {
      },
      formInline: {
        current: 1,
        size: 10,
        templateName: '',
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        current: 1,
        size: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    /***
     * 调用接口，注释上面模拟数据 取消下面注释
     */
    getdata: function (parameter) {
      this.loading=true
      performanceTemplatePage(parameter)
        .then(res => {
          this.loading = false
          if (res.code!=='200') {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            this.listData = res.data.content
            // 分页赋值
            this.pageparm.currentPage = res.data.pages
            this.pageparm.total = res.data.total
            this.loading=false
          }
        })
        .catch(() => {
          this.loading = false
          this.$message.error('绩效模板加载失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parame) {
      this.formInline.current = parame.currentPage
      this.formInline.size = parame.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row !== undefined && row !== 'undefined') {
        this.title = '修改绩效模板'
        this.editForm.templateId = row.templateId
        this.editForm.templateName = row.templateName
        this.editForm.memberHandmade=row.memberHandmade*100
        this.editForm.ordinaryHandmade = row.ordinaryHandmade*100
        this.editForm.newCard = row.newCard*100
        this.editForm.renewCard = row.renewCard*100
      } else {
        this.title = '添加绩效模板'
        this.editForm.templateId = ''
        this.editForm.templateName = ''
        this.editForm.ordinaryHandmade = ''
        this.editForm.memberHandmade = ''
        this.editForm.newCard = ''
        this.editForm.renewCard = ''
      }
    },
    // 编辑、增加页面保存方法
    submitForm() {
      this.postForm.memberHandmade= this.editForm.memberHandmade/100
      this.postForm.ordinaryHandmade =  this.editForm.ordinaryHandmade/100
      this.postForm.newCard =  this.editForm.newCard/100
      this.postForm.renewCard =  this.editForm.renewCard/100
      this.postForm.templateName=this.editForm.templateName
      this.postForm.templateId=this.editForm.templateId
      this.postForm.token=this.editForm.token
      savePerformanceTemplate(this.postForm)
        .then(res => {
          if (res.code==='200') {
            this.$message({
              type: 'success',
              message: '绩效模板保存成功'
            })
            this.editFormVisible = false
            this.getdata(this.formInline)
          } else {
            this.$message({
              type: 'info',
              message: res.message
            })
          }
        }).catch(() => {
        this.$message.error('绩效模板保存失败，请稍后再试！')
      })
    },
    // 绩效模板
    deleteSalaryTemplate(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delPerformanceTemplatePage(row.templateId)
          .then(res => {
            if (res.code==='200') {
              this.$message({
                type: 'success',
                message: '绩效模板已删除!'
              })
              this.getdata(this.formInline)
            } else {
              this.$message({
                type: 'info',
                message: res.message
              })
            }
          }).catch(() => {
          this.loading = false
          this.$message.error('绩效模板删除失败，请稍后再试！')
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
</style>




// WEBPACK FOOTER //
// src/views/mch/SalaryTemplate.vue